import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/SaleTarget";

export const SALE_TARGET_PREFIX_URL = PREFIX_URL;

export const GetSaleTargetByRegion = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetSaleTargetByRegion`, options);

export const GetSaleTargetByProduct = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetSaleTargetByProduct`, options);

export const GetSaleTargetByProductCategory = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetSaleTargetByProductCategory`, options);

export const GetEmployeeBonus = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetEmployeeBonus`, options);

export default {
  GetSaleTargetByRegion,
  GetSaleTargetByProduct,
  GetSaleTargetByProductCategory,
  GetEmployeeBonus,
};
